import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton pour une section de la home (below-the-fold).
 * Utilisé comme fallback Suspense pour PopularCars, HowItWorks, WhyChooseUs, Testimonials, FAQ.
 */
export function HomeSectionSkeleton() {
  return (
    <div className="rakb-home-section px-4 md:px-6 lg:px-8 bg-scandi-bg" aria-hidden="true">
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48 md:w-64" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-40 md:h-48 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}
